import styled from '@emotion/styled'

const Logo = styled.img`
	max-height: 50px;
`
export { Logo }
